<div class="container">
  <div class="row">
    <div class="tab-grp">
      <div class="tabset-container">

        <c11n-tabs *ngIf="innerWidth > 575 else dropDown" [activeItem]="selected.value" (activeItemChange)=onTabChange($event)
                   variant="left-aligned" overflowOption="nav-overflow" hasAnimation="false" dynamicHeight disablePagination="true">
          <c11n-tab-panel *ngFor="let model of premiumDiscountModel;let i = index" [id]="i" role="tablist"
                          aria-label={{model.label}} [labelText]="model.label">
            <app-current [modelLabel]="model.label" *ngIf="selected.value === i" [data]="premiumDiscountModel[i]" [ticker]="ticker"
                         [fundId]="fundId" [shareSplitDate]="shareSplitDate" [shareSplitPrice]="shareSplitPrice">
            </app-current>
          </c11n-tab-panel>
        </c11n-tabs>
        <ng-template #dropDown>
          <c11n-select class="tab-select" [size]="'large'" (stateChange)="onSelectionChange($event)">
            <select c11nSelectInput id="selectId" class="c11n-select__box__select">
              <option *ngFor="let model of premiumDiscountModel;let i = index" aria-label={{model.label}} value="{{i}}">
                {{model.label}}</option>
            </select>
          </c11n-select>
          <br>
          <br>
          <br>
          <app-current [modelLabel]="premiumDiscountModel[activeTab].label" [data]="premiumDiscountModel[activeTab]" [ticker]="ticker" [fundId]="fundId" [shareSplitDate]="shareSplitDate" [shareSplitPrice]="shareSplitPrice">
          </app-current>
        </ng-template>
      </div>
    </div>
  </div>
</div>
